import { BellOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router';
import { Badge } from 'antd';
import React, { useEffect, useState } from 'react';
import { getNotificationCount } from '@/services/ant-design-pro/api';
import styles from './index.module.less';
import { NOTIFICATION_READ_EVENT } from '@/pages/Account/Notifications';

export type SiderTheme = 'light' | 'dark';

export const NoticeIcon = () => {
  const [unreadCount, setUnreadCount] = useState<number>(0);
  const navigate = useNavigate();

  const fetchUnreadCount = async () => {
    try {
      const response = await getNotificationCount();
      if (response.success) {
        setUnreadCount(response.unread);
      }
    } catch (error) {
      console.error('获取未读消息数量失败:', error);
    }
  };

  useEffect(() => {
    fetchUnreadCount();
    // 设置定时刷新，每分钟获取一次
    const timer = setInterval(fetchUnreadCount, 60000);

    // 添加自定义事件监听器，当通知被标记为已读时触发
    const handleNotificationRead = () => {
      fetchUnreadCount();
    };
    window.addEventListener(NOTIFICATION_READ_EVENT, handleNotificationRead);

    return () => {
      clearInterval(timer);
      window.removeEventListener(NOTIFICATION_READ_EVENT, handleNotificationRead);
    };
  }, []);

  const handleClick = () => {
    navigate('/account/notifications');
  };

  return (
    <div className={styles.action} onClick={handleClick}>
      <Badge count={unreadCount} offset={[0, 0]}>
        <BellOutlined style={{ fontSize: '16px' }} />
      </Badge>
    </div>
  );
};
